import React, { type FC } from 'react';
import SelectWithSearch from '../../input/SelectWithSearch/SelectWithSearch';
import type { AdresseVaelgerFund, FslAddress } from './AddressPicker.types';
import { useData } from './AddressPicker.hooks';

interface IAddressPickerProps {
  onChange?: (changes: Partial<FslAddress>) => void;
  error?: boolean;
  helperText?: string;
  title?: string;
  disabled?: boolean;
}

const AddressPicker: FC<IAddressPickerProps> = ({ onChange, error, helperText, title, disabled }) => {
  const { query, options, isOpen, setIsOpen, handleOnChange, handleOnInputChanged, selectedOption } = useData(onChange);

  return (
    <SelectWithSearch<AdresseVaelgerFund>
      value={selectedOption ?? undefined}
      title={title}
      error={error}
      helperText={helperText}
      onChange={handleOnChange}
      options={options}
      inputValue={query}
      onInputChange={handleOnInputChanged}
      updateDelay={50}
      open={isOpen}
      isReadOnly={disabled}
      isDisabled={disabled}
      onOpen={() => setIsOpen(true)}
      filterOptions={(x) => x}
      getOptionLabel={(option) => option.titel}
      getOptionSelected={(l, r) => l.id === r.id}
    />
  );
};

export default AddressPicker;
